import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  useLayoutEffect
} from "react";
import { SessionContext } from "../../context/SessionContext";
import {
  getLtvChannels,
  toggleFavById,
  getChannels,
  toggleLockById
} from "../../api/ltv/ltv";
import localizationStrings from "../../statics/localization";
import {
  addLockToChannel,
  deleteChannelLock
} from "../../api/common/commonApi";
import PasswordModal from "../passwordModal";
import { useHistory } from "react-router-dom";
import Notification from "../notification";
import { addFavorite, deleteFavorite } from "../../api/common/commonApi";
import { sendCustomFavoriteReport } from "../../utils/reporting/customReporting";
import ReturnIcon from "../../assets/icons/svg/ReturnIcon";
import { getColumnList } from "../../api/config/configApi";
import { channelGenres } from "../../api/mockup/mockup";
import TvFavoriteIcon from "../../assets/icons/svg/TvFavoriteIcon";
import TvLockIcon from "../../assets/icons/svg/TvLockIcon";
import BigLockIcon from "../../assets/icons/svg/BigLockIcon";
import AtlasLogo from "../../assets/logo/atlas-logo.png";
import useOutsideClick from "../../utils/useOutsideClick";

import "./favlockchannel.scss";

const LockedChannel = () => {
  const [channels, setChannels] = useState(null);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [askAdminPin, setAskAdminPin] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(3);
  const [genres, setGenres] = useState([]);
  const [selectedGenre, setSelectedGenre] = useState(null);
  const [showGenreOptions, setShowGenreOptions] = useState(false);
  const [showFilterOptions, setShowFilterOptions] = useState(false);
  const allChannels = useRef(null);
  const option1Ref = useRef(null);
  const option2Ref = useRef(null);
  const {
    userFrameConfig,
    profile,
    path,
    adminProfile,
    setIsChangeLockChannel,
    isChangeLockChannel,
    isChildProfile
  } = useContext(SessionContext);
  const history = useHistory();
  const [notificationText, setNotificationText] = useState(null);
  const [selectedLockItem, setSelectedLockItem] = useState(null);
  const [isPasswordFlow, setIsPasswordFlow] = useState(false);

  useOutsideClick(option1Ref, () => {
    setShowGenreOptions(false);
  });

  useOutsideClick(option2Ref, () => {
    setShowFilterOptions(false);
  });

  const getChannelItems = async (columnCode) => {
    //kanal ögelerini al
    const data = await getChannels(columnCode, 1, 500);
    const channels = data.data;
    allChannels.current = data.data;
    setChannels(channels);
  };

  const getGenres = async () => {
    // const data = await getColumnList(userFrameConfig?.TV_Column);
    // if (data.data.returncode === "0") {
    //   let arr = data.data.data;
    setGenres(channelGenres);
    // let colCode = isChildProfile
    //   ? userFrameConfig?.ChildMode_TV_Column_All
    //   : userFrameConfig?.TV_Column_All;
    setSelectedGenre(channelGenres[0]);
  };
  useEffect(() => {
    getChannelItems();
  }, []);
  const clickConfirm = () => {
    setShowNotification(false);
    setShowPasswordModal(false);
    setSelectedLockItem(null);
    setIsPasswordFlow(false);
    setNotificationText(null);

    history.push(`/profile/${profile?.id}`);
  };

  const clickNotConfirm = () => {
    setShowNotification(false);
    setSelectedLockItem(null);
    setShowPasswordModal(false);
    //history.push(`${path}/settings/main`);
  };

  const onClickLockIcon = (item) => {
    const isLocked = item?.interactions?.find(
      (element) => element === "CHANNEL_LOCK"
    );

    let textObject = {};

    if (profile?.hasPin) {
      setSelectedLockItem(item);
      setShowPasswordModal(true);
      setIsPasswordFlow(true);

      textObject.confirmText = localizationStrings.enter;
      textObject.text = isLocked
        ? localizationStrings.profile.enterProfilePasswordToUnlock
        : localizationStrings.profile.enterProfilePasswordToLock;
    } else {
      setSelectedLockItem(null);
      setShowPasswordModal(false);
      setIsPasswordFlow(false);

      textObject.text = localizationStrings.createProfilePinCodeText;
      textObject.confirmText = localizationStrings.createProfilePinCode;
    }

    setNotificationText(textObject);
    setShowNotification(true);
  };

  const handleToggleLockWithPin = async (channelId, validatedPin = null) => {
    try {
      if (!isPasswordFlow || !showPasswordModal) {
        return;
      }

      const pinToUse = validatedPin || profile?.pin;

      if (!pinToUse) {
        return;
      }

      const { data } = await toggleLockById(channelId, pinToUse);

      const isLocked = data?.find((element) => element === "CHANNEL_LOCK");

      if (channelId) {
        allChannels.current = allChannels.current.map((item) => {
          if (item.id === channelId) {
            if (isLocked) {
              return {
                ...item,
                interactions: item.interactions.includes("CHANNEL_LOCK")
                  ? item.interactions
                  : [...item.interactions, "CHANNEL_LOCK"]
              };
            } else {
              return {
                ...item,
                interactions: item.interactions.filter(
                  (interaction) => interaction !== "CHANNEL_LOCK"
                )
              };
            }
          }
          return item;
        });

        filterChannel(selectedGenre, selectedFilter);
      }
    } catch (error) {
      console.error("Lock toggle error:", error);
    }
  };

  const filterChannel = (genre = selectedGenre, type = selectedFilter) => {
    let filtered = [];
    let genreFilter = [];

    setSelectedGenre(genre);
    setSelectedFilter(type);

    genreFilter = allChannels.current.filter(
      (item) => item.genre === genre.name
    );

    if (genreFilter.length === 0) {
      genreFilter = allChannels.current;
    }
    if (type === 1) {
      filtered = genreFilter.filter((item) => {
        return item.interactions.find(
          (interaction) => interaction === "CHANNEL_LOCK"
        );
      });
    } else if (type === 2) {
      filtered = genreFilter.filter((item) => {
        return item.interactions.find(
          (interaction) => interaction === "CHANNEL_FAV"
        );
      });
    } else if (type === 3) {
      filtered = genreFilter;
    } else {
      return;
    }
    setChannels(filtered);
  };

  useLayoutEffect(() => {
    if (isChildProfile) {
      let arr = [
        {
          columnname: localizationStrings.child,
          columncode: userFrameConfig?.ChildMode_TV_Column_All
        },
        {
          columncode: "fav-channel",
          columnname: localizationStrings.favChannel
        }
      ];
      setSelectedGenre();
      setGenres(arr);
    } else {
      getGenres();
    }
  }, [userFrameConfig]);

  useEffect(() => {
    if (userFrameConfig) {
      let columnCode = isChildProfile
        ? userFrameConfig?.ChildMode_TV_Column_All
        : userFrameConfig?.TV_Column_All;
      getChannelItems(columnCode);
    }
    return () => {
      if (path?.includes("/livetv")) {
        setIsChangeLockChannel(
          isChangeLockChannel ? (isChangeLockChannel === "1" ? "2" : "1") : "1"
        );
      }
    };
  }, [userFrameConfig]);

  useEffect(() => {
    if (isChangeLockChannel && userFrameConfig) {
      const columnCode = isChildProfile
        ? userFrameConfig?.ChildMode_TV_Column_All
        : userFrameConfig?.TV_Column_All;

      getChannelItems(columnCode);
    }
  }, [isChangeLockChannel, userFrameConfig, isChildProfile]);

  // useEffect(() => {
  //   if (profile) {
  //     //adminProfile
  //     if (profile?.hasPin) {
  //       //setShowPasswordModal(true);
  //     } else {
  //       setShowNotification(true);
  //     }
  //     // if (profile?.profileroleid === userFrameConfig.Kids_Profile_Id) {
  //     //   setAskAdminPin(true);
  //     //   if (adminProfile.havepwd === "1") {
  //     //     setShowPasswordModal(true);
  //     //   } else {
  //     //     setShowNotification(true);
  //     //   }
  //     // } else if (profile.havepwd === "1") {
  //     //   setShowPasswordModal(true);
  //     // } else {
  //     //   setShowNotification(true);
  //     // }
  //   }
  // }, [profile]);

  const renderedItems = channels?.map((item, index) => {
    return (
      <LockChannelItem
        key={item.channelcode}
        item={item}
        index={index}
        channels={channels}
        selectedGenre={selectedGenre}
        profile={profile}
        setShowNotification={setShowNotification}
        setLockChannelCode={(channelId) => {
          if (channelId) {
            allChannels.current = allChannels.current.map((item) => {
              if (item.id === channelId) {
                if (item.interactions.includes("CHANNEL_LOCK")) {
                  return {
                    ...item,
                    interactions: item.interactions.filter(
                      (interaction) => interaction !== "CHANNEL_LOCK"
                    )
                  };
                } else {
                  return {
                    ...item,
                    interactions: [...item.interactions, "CHANNEL_LOCK"]
                  };
                }
              }
              return item;
            });
          }
        }}
        setFavChannelCode={(channelId) => {
          if (channelId) {
            allChannels.current = allChannels.current.map((item) => {
              if (item.id === channelId) {
                if (item.interactions.includes("CHANNEL_FAV")) {
                  return {
                    ...item,
                    interactions: item.interactions.filter(
                      (interaction) => interaction !== "CHANNEL_FAV"
                    )
                  };
                } else {
                  return {
                    ...item,
                    interactions: [...item.interactions, "CHANNEL_FAV"]
                  };
                }
              }
              return item;
            });
          }
        }}
        refilterChannels={() => filterChannel(selectedGenre, selectedFilter)}
        onClickLockIcon={onClickLockIcon}
      />
    );
  });

  return (
    <div className="settings-container">
      <div
        className="settings-icon"
        style={{
          position: "fixed",
          left: `${(33 / 1920) * 100}vw`,
          top: `calc(${(72 / 1920) * 100}vw + ${(49 / 1920) * 100}vw)`,
          zIndex: 5,
          margin: 0,
          gap: "10px"
        }}
        onClick={() => {
          history.push(`/dashboard/settings`);
        }}
      >
        <ReturnIcon />
        <div className="icon-settings">{localizationStrings.back}</div>
      </div>
      <div className="pc-header">
        <img className="pc-logo" src={AtlasLogo} alt="Atlas" />
        <div className="pc-title">{localizationStrings.favAndLock}</div>
      </div>
      <div className="select-box-row favlockchannel">
        {/* <div
          ref={option1Ref}
          className={`settings-select-box ${showGenreOptions ? "opened" : ""}`}
          onClick={() => setShowGenreOptions(!showGenreOptions)}
        >
          <span>{selectedGenre?.name}</span>
          <div className="icon arrow-down"></div>
          <div
            className={`primary-select-box-options ${
              showGenreOptions ? "show" : ""
            }`}
            style={{ top: "3.5vw" }}
          >
            {genres?.map((item) => {
              return (
                <div
                  className="option"
                  onClick={() => {
                    setSelectedGenre(item);
                    filterChannel(item);
                  }}
                >
                  <div
                    className={`option-text ${
                      selectedGenre?.columncode === item.columncode
                        ? "selected"
                        : ""
                    }`}
                  >
                    {item?.name}
                  </div>
                </div>
              );
            })}
          </div>
        </div> */}

        <label className="settings-period">
          <span>{localizationStrings.filter}</span>
          <select
            value={selectedFilter || 3}
            onChange={(event) =>
              filterChannel(undefined, Number(event.target.value))
            }
          >
            <option value={3}>{localizationStrings.searchFilters.all}</option>
            <option value={1}>{localizationStrings.lockedChannels}</option>
            <option value={2}>{localizationStrings.favChannel}</option>
          </select>
        </label>
      </div>
      <div className="list-history">
        {renderedItems}
        {channels !== null && !channels?.length ? (
          <div className="not-found">{localizationStrings.noChannelFound}</div>
        ) : null}
      </div>

      {showNotification ? (
        <Notification
          text={notificationText?.text}
          confirmText={notificationText?.confirmText}
          notConfirmText={localizationStrings.cancel}
          onClickConfirm={() => {
            if (!isPasswordFlow) {
              clickConfirm();
            }
          }}
          onClickNotConfirm={() => {
            setShowNotification(false);
            setShowPasswordModal(false);
            setSelectedLockItem(null);
            setIsPasswordFlow(false);
            setNotificationText(null);
          }}
          isPassword={showPasswordModal}
          theme="no-bg"
          logo={true}
          sendResult={(val, validatedPin) => {
            // Creation navigates in onClickConfirm after the dialog closes.
            // Unmounting here would cancel Notification's delayed callback.
            if (!isPasswordFlow) return;
            if (
              isPasswordFlow &&
              showPasswordModal &&
              val &&
              selectedLockItem?.id
            ) {
              handleToggleLockWithPin(selectedLockItem.id, validatedPin);
            }
            setShowNotification(false);
            setShowPasswordModal(false);
            setSelectedLockItem(null);
            setIsPasswordFlow(false);
            setNotificationText(null);
          }}
          profileCode={profile?.id}
        />
      ) : null}
    </div>
  );
};

const LockChannelItem = ({
  item,
  channels,
  setChannels,
  selectedGenre,
  profile,
  setLockChannelCode,
  setFavChannelCode,
  setShowNotification,
  onClickLockIcon,
  refilterChannels
}) => {
  const [isLocked, setIsLocked] = useState(false);
  const [isFav, setIsFav] = useState(false);

  const handleToggleFav = async (item) => {
    try {
      const { data } = await toggleFavById(item.id);
      if (data) {
        setFavChannelCode(item.id);
        refilterChannels();
      }
    } catch (error) {
      console.error("fav function error because of:", error);
    }
  };

  useEffect(() => {
    const isFavourite = item?.interactions?.find(
      (element) => element === "CHANNEL_FAV"
    );

    const isLock = item?.interactions?.find(
      (element) => element === "CHANNEL_LOCK"
    );

    setIsFav(!!isFavourite);
    setIsLocked(!!isLock);
  }, [item?.interactions]);

  return (
    <div className="favlockchannel-list-item" style={{ width: "100%" }}>
      <div className="favlockchannel-logo">
        <img className="logo" alt={item.channelname} src={`${item.logo}`} />
      </div>
      <div className="seperate"></div>
      <div className="favlockchannel-info">
        <div className="favlockchannel-name">{item?.name}</div>
        {/* <div className="favlockchannel-time">01:00 - 01:30</div> */}
      </div>
      <div className="favlockchannel-icons">
        <button
          type="button"
          aria-label={`${localizationStrings.lock || "Lock"} · ${item.name}`}
          aria-pressed={isLocked}
          className={`icon ${isLocked ? "fill-yellow" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            onClickLockIcon(item);
          }}
        >
          <TvLockIcon isLocked={isLocked} />
        </button>
        <button
          type="button"
          aria-label={`${localizationStrings.favChannel} · ${item.name}`}
          aria-pressed={isFav}
          className={`icon ${isFav ? "fill-red" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            handleToggleFav(item);
          }}
        >
          <TvFavoriteIcon isFavorite={isFav} />
        </button>
      </div>
    </div>
  );
};

export default LockedChannel;
